import React from 'react'
import { IconProps } from './types'

export const HalfEyeIcon: React.FC<IconProps> = ({
  size = 19,
  fill = 'white',
  stroke = 'white'
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='5 5 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2014_58)'>
        <path
          d='M27.7915 23.2311C27.7915 24.5019 27.2866 25.7207 26.388 26.6193C25.4894 27.518 24.2706 28.0228 22.9998 28.0228C21.729 28.0228 20.5102 27.518 19.6116 26.6193C18.713 25.7207 18.2081 24.5019 18.2081 23.2311C18.2081 21.9603 18.713 20.7415 19.6116 19.8429C20.5102 18.9443 21.729 18.4395 22.9998 18.4395C24.2706 18.4395 25.4894 18.9443 26.388 19.8429C27.2866 20.7415 27.7915 21.9603 27.7915 23.2311Z'
          stroke={stroke}
          strokeWidth='1.91667'
          strokeLinecap='round'
          strokeLinejoin='round'
        ></path>
        <path
          d='M9.58313 23.2311C11.7298 17.0612 16.7423 12.6895 22.9998 12.6895C29.2573 12.6895 34.2698 17.0612 36.4165 23.2311C34.2698 29.401 29.2573 33.7728 22.9998 33.7728C16.7423 33.7728 11.7298 29.401 9.58313 23.2311Z'
          stroke={stroke}
          strokeWidth='1.91667'
          strokeLinecap='round'
          strokeLinejoin='round'
        ></path>
      </g>
      <g clipPath='url(#clip1_2014_58)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22.9997 12.6875C16.7421 12.6875 11.7297 17.0593 9.58301 23.2292C11.7297 29.3991 16.7421 33.7708 22.9997 33.7708C29.2572 33.7708 34.2697 29.3991 36.4163 23.2292C34.2697 17.0593 29.2572 12.6875 22.9997 12.6875ZM26.3879 26.6174C27.2865 25.7188 27.7913 24.5 27.7913 23.2292C27.7913 21.9583 27.2865 20.7396 26.3879 19.8409C25.4893 18.9423 24.2705 18.4375 22.9997 18.4375C21.7288 18.4375 20.5101 18.9423 19.6115 19.8409C18.7128 20.7396 18.208 21.9583 18.208 23.2292C18.208 24.5 18.7128 25.7188 19.6115 26.6174C20.5101 27.516 21.7288 28.0208 22.9997 28.0208C24.2705 28.0208 25.4893 27.516 26.3879 26.6174Z'
          fill={fill}
        ></path>
        <path
          d='M9.58301 23.2292L8.67789 22.9143C8.60693 23.1182 8.60693 23.3401 8.67789 23.5441L9.58301 23.2292ZM36.4163 23.2292L37.3215 23.5441C37.3924 23.3401 37.3924 23.1182 37.3215 22.9143L36.4163 23.2292ZM26.3879 19.8409L27.0655 19.1633L27.0655 19.1633L26.3879 19.8409ZM19.6115 26.6174L20.2891 25.9397L20.2891 25.9397L19.6115 26.6174ZM10.4881 23.5441C12.5343 17.6631 17.2434 13.6458 22.9997 13.6458V11.7292C16.2408 11.7292 10.9251 16.4555 8.67789 22.9143L10.4881 23.5441ZM22.9997 32.8125C17.2434 32.8125 12.5343 28.7952 10.4881 22.9143L8.67789 23.5441C10.9251 30.0029 16.2408 34.7292 22.9997 34.7292V32.8125ZM35.5112 22.9143C33.4651 28.7952 28.7559 32.8125 22.9997 32.8125V34.7292C29.7585 34.7292 35.0743 30.0029 37.3215 23.5441L35.5112 22.9143ZM22.9997 13.6458C28.7559 13.6458 33.4651 17.6631 35.5112 23.5441L37.3215 22.9143C35.0743 16.4555 29.7585 11.7292 22.9997 11.7292V13.6458ZM26.833 23.2292C26.833 24.2458 26.4291 25.2209 25.7103 25.9397L27.0655 27.295C28.1439 26.2167 28.7497 24.7542 28.7497 23.2292H26.833ZM25.7103 20.5186C26.4291 21.2375 26.833 22.2125 26.833 23.2292H28.7497C28.7497 21.7042 28.1439 20.2416 27.0655 19.1633L25.7103 20.5186ZM22.9997 19.3958C24.0163 19.3958 24.9914 19.7997 25.7103 20.5186L27.0655 19.1633C25.9872 18.085 24.5247 17.4792 22.9997 17.4792V19.3958ZM20.2891 20.5186C21.008 19.7997 21.983 19.3958 22.9997 19.3958V17.4792C21.4747 17.4792 20.0121 18.085 18.9338 19.1633L20.2891 20.5186ZM19.1663 23.2292C19.1663 22.2125 19.5702 21.2375 20.2891 20.5186L18.9338 19.1633C17.8555 20.2416 17.2497 21.7042 17.2497 23.2292H19.1663ZM20.2891 25.9397C19.5702 25.2209 19.1663 24.2458 19.1663 23.2292H17.2497C17.2497 24.7542 17.8555 26.2167 18.9338 27.295L20.2891 25.9397ZM22.9997 27.0625C21.983 27.0625 21.008 26.6586 20.2891 25.9397L18.9338 27.295C20.0121 28.3734 21.4747 28.9792 22.9997 28.9792V27.0625ZM25.7103 25.9397C24.9914 26.6586 24.0163 27.0625 22.9997 27.0625V28.9792C24.5247 28.9792 25.9872 28.3734 27.0655 27.295L25.7103 25.9397Z'
          fill={fill}
        ></path>
      </g>
      <defs>
        <clipPath id='clip0_2014_58'>
          <rect
            width='17.25'
            height='30.5'
            fill={fill}
            transform='translate(23 5.02344)'
          ></rect>
        </clipPath>
        <clipPath id='clip1_2014_58'>
          <rect
            width='15.3333'
            height='34.5'
            fill={fill}
            transform='matrix(-1 0 0 1 23 5.02344)'
          ></rect>
        </clipPath>
      </defs>
    </svg>
  )
}
